export default "__VITE_ASSET__BYYlV31i__"